import React from 'react';
import WaterfallDisplay from 'pages/Waterfall/WaterfallDisplay/WaterfallDisplay';

const WaterfallView = () => (<WaterfallDisplay/>);

export default WaterfallView;
